<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="fixation">
			<Swiper></Swiper>
			<!-- <Hot></Hot> -->
			<Commodity></Commodity>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	import Swiper from '../../components/swiper.vue'
	// import Hot from '../../components/hot.vue'
	import Commodity from '../../components/commodity.vue'
	export default {
		name: 'index',
		components:{
			Head,Foot,Swiper,Commodity
		},
		// components:{
		// 	Head,Foot,Swiper,Hot,Commodity
		// },
		data(){
			return {
				
			}
		},
		methods:{
			
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
</style>
